module.exports = __webpack_public_path__ + "img/material-symbols.a518542e.svg";